import moment from 'moment';

import { formatValue, getAddedOrDeletedMessage, getValClassName, isItemAdded, renderEdition } from './common';

import type { ChangelogRule } from './types';

export const FLIGHTS_ORDER = 500;

function formatFlightValue(field: unknown, value: unknown): string {
  if (typeof field === 'string' && field.includes('Date') && value) {
    return moment(value as moment.MomentInput).format('YYYY-MM-DD');
  }
  return formatValue(value);
}

function getFlightName(value: unknown): unknown {
  return value && typeof value === 'object' && 'name' in value ? value.name : undefined;
}

export const flightsRules: ChangelogRule[] = [
  {
    format: (change, context) => {
      const field = change.path?.[2];
      return renderEdition(
        `${context.entity} ${context.formatMessage({ defaultMessage: 'Flight', id: 'changelogModal.message.flight' })} ${field}`,
        formatFlightValue(field, change.lhs),
        formatFlightValue(field, change.rhs),
        context
      );
    },
    order: FLIGHTS_ORDER,
    regex: /^E\.flights\.\d+\./,
    section: 'flights'
  },
  {
    format: (change, { entity, formatMessage }) => {
      const added = isItemAdded(change);
      const name = getFlightName(added ? change.item?.rhs : change.item?.lhs);
      return (
        <div className={getValClassName(added ? 'add' : 'delete')}>
          <b>
            {`${entity} ${formatMessage({ defaultMessage: 'Flight', id: 'changelogModal.message.flight' })} ${formatValue(
              name
            )} ${getAddedOrDeletedMessage(added, formatMessage)}`}
          </b>
        </div>
      );
    },
    order: FLIGHTS_ORDER,
    regex: /^A\.flights$/,
    section: 'flights'
  }
];
